/*
  - Side menu component displays navbar options
  - Change password, logout , profile functionality
  - Commented by sarthak on Feb 19, 2024
*/
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { onSideNavChange, animateText } from "../animations";
import { SidenavService } from "./sidenav.service";
// import { Options } from "../../interfaces/options";
import { AuthenticationServiceService } from "../../authentication-service.service";
import { MenuService } from "../../menu.service";
import { ChangeUsersService } from "../../services/change-users.service";
import { BackendApiService } from "../../services/backend-api.service";
import { ConvertDatetimePipe } from "../../convert-datetime.pipe";
// import * as cloudapi from '../../../assets/cloud_api_config.json';
import { RouterOutlet } from '@angular/router';
import { environment } from "../../../environments/environment";
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { BaseUrlConstantsService } from "../../services/base-url-constants.service";
import { Observable } from "rxjs";
import { DialogOverviewExampleDialogComponent } from "../../../components/dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
interface Page {
  link: string;
  name: string;
  icon: string;
}
@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu.component.html",
  styleUrls: ["./side-menu.component.scss"],
  animations: [onSideNavChange, animateText],
  standalone:true,
  imports:[RouterOutlet,CommonModule,MatMenuModule,MatButtonModule,MatIcon]
})
export class SideMenuComponent implements OnInit {
  public DSPkey = BaseUrlConstantsService.DSP_KEY;
  public Cgkey = BaseUrlConstantsService.CG_KEY;
  public imageBaseV2Url = BaseUrlConstantsService.NEW_IMAGE_RELATIVE_BASE_URL;
  public imageBaseUrl = BaseUrlConstantsService.IMAGE_RELATIVE_URL + "uploads/";
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public editUserUrl = BaseUrlConstantsService.EDIT_USER_INFO;
  public imageUploadUrl = BaseUrlConstantsService.IMAGE_UPLOAD;
  public role: any;
  public name: string;
  public menu: Array<any> = [];
  public breadcrumbList: Array<any> = [];
  public isUserLoggedIn: boolean;
  public serve: any;
  public isLoggedIn$: Observable<boolean>;
  public userStatus: string;
  public isOpen: boolean;
  public rotatingAssetCount: number | null = null;
  public loading = false;
  public color = "primary";
  public siteID: any;
  public userSites: any = [];
  public userGroups: any = [];
  public mode = "determinate";
  public groupList: any = [];
  public value = 50;
  public bufferValue = 75;
  public optionsTwo: any = [];
  public topItem1: string;
  public topItem2: string;
  public loadSites: Boolean = false;
  public today: any;
  public myDate: any;
  public term1: any;
  public logInUserID: any;
  public optionsSecond: any;
  public options: any = [
    {
      icon: "dashboard",
      color: "#21b51d",
      title: "Assets",
      page: "device-reports",
    },
  ];
  public ON_PREM = BaseUrlConstantsService.ON_PREM;
  public PRODUCTION = BaseUrlConstantsService.PRODUCTION_KEY;
  public roleType: string;
  public menu_second: any = [];
  public term: any;
  public menu_second2: any = [];
  public menu_Group: any = [];
  public menuGroup1: any = [];
  public userName: string;
  public currentDate: any;
  public menu_site: any = [];
  public customer: any;
  public groupFil: any;
  public userID: string;
  public sitesList: any = [];
  public sideNavState = false;
  public linkText = false;
  public _cmpnyName: any;
  public shouldShow: boolean;
  public _userImg: any = "";
  public pages: Page[] = [
    { name: "Inbox", link: "some-link", icon: "inbox" },
    { name: "Starred", link: "some-link", icon: "star" },
    { name: "Send email", link: "some-link", icon: "send" },
  ];
  public siteTitle = "All Sites";
  public applicationTitle = "All Applications";
  public token: string;
  public componyLogo: any = "";
  public showlogo: boolean = true;
  public CCAS_site_id: number;
  public sub_user_logo: any = null;
  public selectedNav:string="Home"
  public associated_clientid = null
  public showRokadeLogo=false
  /*
    - Initializes all services to be used in component
    - changes userDashboard and loaderStatus
    - calls utcTime()
    - Commented by sarthak on feb 19, 2024
  */
  constructor(
    private changeService: ChangeUsersService,
    private cdRef: ChangeDetectorRef,
    private service: BackendApiService,
    private _sidenavService: SidenavService,
    private menuService: MenuService,
    private router: Router,
    public dialog: MatDialog,
    private authenticationService: AuthenticationServiceService,
    public changeUserDashboard: ChangeUsersService
  ) {
    changeUserDashboard.getLoggedInStatus.subscribe((result) =>
      this.changeUserDash(status)
    );
    changeUserDashboard.getLoaderStatus.subscribe((result) =>
      this.loaderStatus(result)
    );
    this.customer = localStorage.getItem("customerName");
    this.utcTime();
    // if(this.DSPkey==true){
    //   cloudapi[`default`][0].label="DSP Server"
    //   cloudapi[`default`][0].value="http://api.iotdsp.saildsp.co.in/middleware"

    // }
    // else{
    //   cloudapi[`default`][0].label="DEV"
    //   cloudapi[`default`][0].value="xyzz"
    // }
  }

  getallSitesAndGroupsInfo(clientid) {}

  onSinenavToggle() {
    this.sideNavState = !this.sideNavState;
    setTimeout(() => {
      this.linkText = this.sideNavState;
    }, 200);
    this._sidenavService.sideNavState$.next(this.sideNavState);
  }
  /*
    - Routes to change-password page to change password
    - Commented by Sarthak on Feb 19, 2024
  */
  openChangePassword() {
    this.router.navigate(["change-password"]);
  }
  /*
    - Displays the clock on top right side
    - Commented by sarthak on Feb 19, 2024
  */
  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
      const time = date + ":" + houre + ":" + second;
      this.myDate = JSON.parse(JSON.stringify(time));
    }, 1000);
  }

  menuBtnOpened() {
    this.shouldShow = false;
  }

  menuBtnClose() {}
  /*
      - This function isnot called anywhere
      - Commented by sarthak on Feb 19, 2024
    */
  searchBYSiteName(ev) {
    const term = ev.toLowerCase();
    this.menu_site = this.userSites.filter(function (tag) {
      return tag.name.toLowerCase().indexOf(term) >= 0;
    });
  }
  /*
      - This function isnot called anywhere
      - Commented by sarthak on Feb 19, 2024
    */
  searchBYGroupName(ev) {
    const term1 = ev.toLowerCase();
    this.menu_Group = this.userGroups.filter(function (tag) {
      return tag.name.toLowerCase().indexOf(term1) >= 0;
    });
  }
  /*
    - Displays content of loader
    - Commented by Sarthak on Feb 19, 2024
  */
  async loaderStatus(status) {
    this.CCAS_site_id = parseInt(localStorage.getItem("associated_clientid"));
    this.customer = localStorage.getItem("customerName");
    if (status) {
      setTimeout(() => {
        this.loading = status;
      }, 0);
    } else {
      setTimeout(() => {
        this.loading = status;
      }, 0);
    }
  }
  /*
    - Clears all values saved in localStorage closes all dialog boxes
    - Changes userdashboard to login page
    - Commented by Sarthak on Feb 19, 2024
  */
  async onLogout() {
    localStorage.clear();
    this.dialog.closeAll();
    localStorage.setItem("loginStatus", "no");
    this.changeUserDashboard.login("Log In");
    this.authenticationService.logout();
    this.isOpen = false;
    this.router.navigate(['/login']);
  }
  /*
    - Handles display of profile or Company Image
    - sets values of different variables from localStorage
    - Depending upon role of user different navbar otions are displayed
    - Commented by Sarthak on Feb 19, 2024
  */
  async changeUserDash(status: string) {
    this.showProfileImage();
    this.userID = localStorage.getItem("user_id");
    this.userName = localStorage.getItem("user_name");
    this._cmpnyName = localStorage.getItem("company_name");
    this.customer = localStorage.getItem("customerName");
    this.roleType = localStorage.getItem("role");
    this.associated_clientid = localStorage.getItem("associated_clientid")
    this.showRokadeLogo = this.shouldShowElement()
    this.fetchProductCount();
    if (localStorage.getItem("loginStatus") === "yes") {
      this.isOpen = true;
      this.isUserLoggedIn = true;
    } else {
      this.isOpen = false;
      this.isUserLoggedIn = false;
    }
    switch (localStorage.getItem("role")) {
      case "ADMIN":
        this.options = [
          {
            icon: "home",
            color: "#21b51d",
            title: "Home",
            page: "/admin-dashborad",
          },
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/clients",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Devices",
            page: "/view-device-type",
          },
          // {
          //   icon: "featured_play_list",
          //   color: "#bdd213",
          //   title: "Licence",
          //   page: "/licence-management",
          // }
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Account managers",
          //   page: "/admin-users",
          // },
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Site Incharge",
          //   page: "/site-incharge",
          // }

          {
            icon: "device-versioning",
            color: "#00ffe7",
            title: "Versioning",
            page: "/device-versioning",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Operational Reports",
            page: "/operational-reports",
          },
          {
            icon: "Site_maintenance",
            color: "#DC143C",
            title: "Site Maintenance",
            page: "/site-maintenance",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
          {
            icon: "Device Usage",
            color: "#DC143C",
            title: "Device Usage",
            page: "/device-usage",
          },
          {
            icon: "Clients Subscription",
            color: "#DC143C",
            title: "Clients Subscription",
            page: "/clients-subscription",
          }
        ];
        if(this.PRODUCTION === false) {
          this.options.push(          {
            icon: "Uptime",
            color: "#DC143C",
            title: "Uptime",
            page: "/uptime-dashboard",
          },);
        }
        break;
      case "CLIENT":
        this.options = [
          {
            icon: "build",
            color: "#7FFFD4",
            title: "Assets",
            page: "/device-reports",
          },
          {
            icon: "account_circle",
            color: "#F0E68C",
            title: "Users",
            page: "/users",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Sites & Applications",
            page: "/site-groups",
          },

          // {
          //   icon: "group_work",
          //   color: "#DC143C",
          //   title: "Reports",
          //   page: "/reports",
          // },

          {
            icon: "group_work",
            color: "#DC143C",
            title: "Operational Reports",
            page: "/operational-reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
          {
            icon: "My Subscription",
            color: "#DC143C",
            title: "My Subscription",
            page: "/my-subscription",
          }
          // {
          //   icon: 'group_work',
          //   color: '#DC143C',
          //   title: 'Alert Settings',
          //   page:'#',
          // },
          // {
          //   icon: 'group_work',
          //   color: '#DC143C',
          //   title: 'Error Log',
          //   page: '/Error-log',
          // }
        ];
        // if(!this.ON_PREM) {
        //   this.options.push({
        //     icon: "My Subscription",
        //     color: "#DC143C",
        //     title: "My Subscription",
        //     page: "/my-subscription",
        //   });
        // }
        break;
      case "USER":
        this.options = [
          {
            icon: "dashboard",
            color: "#21b51d",
            title: "Assets",
            page: "/device-reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },

        ];
        break;
      case "ACCOUNT_MANAGER":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/manager-client-list",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
        ];
        break;
      case "SITE_INCHARGE":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/incharge-client-list",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
        ];
        break;
      case "OEM":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/OEM-Client",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
        ];
        break;
    }
  }

  ngOnDestroy() {
    this.changeUserDashboard.getLoggedInStatus.unsubscribe();
  }

  selectItem(item: string, siteId: any, i) {
    if (item === "All") {
      this.siteTitle = "All Sites";
      localStorage.setItem("fromGroup", "no");
      this.menuService.getNavItem(0);
      this.menu_site = this.userSites;
      this.menu_Group = this.userGroups;
    } else {
      this.siteTitle = item;
      localStorage.setItem("fromGroup", "no");
      this.menuService.getNavItem(siteId);
    }
    for (let first = 0; first < this.menu_site.length; first++) {
      if (this.menu_site[first].name === item) {
        this.menu_site[first].color = "#646464";
      } else {
        this.menu_site[first].color = "";
      }
    }
  }

  selectItem1(item1, groupid) {
    if (item1 === "All") {
      this.applicationTitle = "All Applications";
      localStorage.setItem("fromGroup", "yes");
      this.menuService.getNavItem(0);
      this.menu_site = this.userSites;
      this.menu_Group = this.userGroups;
    } else {
      this.applicationTitle = item1;
      localStorage.setItem("fromGroup", "yes");
      this.menuService.getNavItem(groupid);
    }
    for (let first1 = 0; first1 < this.menu_Group.length; first1++) {
      if (this.menu_Group[first1].name === item1) {
        this.menu_Group[first1].color = "#646464";
      } else {
        this.menu_Group[first1].color = "";
      }
    }
  }
  /*
    - This function isn't called anywhere
    - Commented by sarthak on Feb 19, 2024
  */
  onOpenedChange(ev) {
    if (ev) {
      const element = document.getElementById("div1");
      element.classList.add("left_nav_collapse");
    } else {
      const element = document.getElementById("div1");
      element.classList.remove("left_nav_collapse");
    }
  }
  /*
    - Initialize values saved in local Storage : userId,customer,companyName,username,roleType,isLoggedIn
    - If loginStatus is equal to yes profile picture is displayed
    - depending upon role of user as Client or Admin or User or Account Manager or Site Incharge different navigation optionsare displayed
    - Commented by Sarthak on Feb 19, 2024
  */

   shouldShowElement() {
  // console.log(" USER ID ", this.userID)
  // console.log(" Associated client id  ",this.associated_clientid)
  // console.log(" ROLE ", this.customer )
if (this.customer == 'ADMIN') {
  // console.log("Returning false for admin");
    return false; // Block for admin
  }

  if (this.customer == 'CLIENT') {
    // console.log("Returning for Client",this.userID == '658' );
    return this.userID == '658'; // USER ID should be 658
  }

  if (this.customer == 'USER') {
    //  console.log("Returning for User",this.associated_clientid == '658' );
    return this.associated_clientid == '658'; // Associated ID should be 658
  }

  return false;
}
  ngOnInit() {
    console.log("--------------------------NG on init called ------------------------------");
     this.associated_clientid = localStorage.getItem("associated_clientid")
    this.userID = localStorage.getItem("user_id");
    this.fetchProductCount();
    if (localStorage.getItem("loginStatus") === "yes") {
      this.showProfileImage();
      this.isOpen = true;
      this.isUserLoggedIn = true;
    } else {
      this.isOpen = false;
      this.isUserLoggedIn = false;
    }
    this.customer = localStorage.getItem("customerName");
    this._cmpnyName = localStorage.getItem("company_name");
    this.userName = localStorage.getItem("user_name");
    this.roleType = localStorage.getItem("role");
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
    this.showRokadeLogo = this.shouldShowElement()
    switch (localStorage.getItem("role")) {
      case "ADMIN":
        this.options = [
          {
            icon: "home",
            color: "#21b51d",
            title: "Home",
            page: "/admin-dashborad",
          },
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/clients",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Devices",
            page: "/view-device-type",
          },
          // {
          //   icon: "featured_play_list",
          //   color: "#bdd213",
          //   title: "Licence",
          //   page: "/licence-management",
          // }
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Account managers",
          //   page: "/admin-users",
          // },
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Site Incharge",
          //   page: "/site-incharge",
          // }
          {
            icon: "device-versioning",
            color: "#00ffe7",
            title: "Versioning",
            page: "/device-versioning",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Operational Reports",
            page: "/operation-reports",
          },
          {
            icon: "Site_maintenance",
            color: "#DC143C",
            title: "Site Maintenance",
            page: "/site-maintenance",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
          {
            icon: "Device Usage",
            color: "#DC143C",
            title: "Device Usage",
            page: "/device-usage",
          },
          {
            icon: "Clients Subscription",
            color: "#DC143C",
            title: "Clients Subscription",
            page: "/clients-subscription",
          }
        ];
        if(this.PRODUCTION === false) {
          this.options.push({
            icon: "Uptime",
            color: "#DC143C",
            title: "Uptime",
            page: "/uptime-dashboard",
          },);
        }
        break;
      case "CLIENT":
        this.options = [
          {
            icon: "build",
            color: "#7FFFD4",
            title: "Assets",
            page: "/device-reports",
          },
          {
            icon: "account_circle",
            color: "#F0E68C",
            title: "Users",
            page: "/users",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Sites & Applications",
            page: "site-groups",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Operational Reports",
            page: "/operation-reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
          {
            icon: "My Subscription",
            color: "#DC143C",
            title: "My Subscription",
            page: "/my-subscription",
          }

          // {
          //   icon: 'group_work',
          //   color: '#DC143C',
          //   title: 'Alert Settings',
          //   page:'#',
          //   },
          // {
          //   icon: 'group_work',
          //   color: '#DC143C',
          //   title: 'Error Log',
          //   page: '/Error-log',
          // }
        ];
        // if(!this.ON_PREM) {
        //   this.options.push({
        //     icon: "My Subscription",
        //     color: "#DC143C",
        //     title: "My Subscription",
        //     page: "/my-subscription",
        //   });
        // }
        break;
      case "USER":

        this.options = [
          {
            icon: "dashboard",
            color: "#21b51d",
            title: "Assets",
            page: "/device-reports",
          },
          // {
          //   icon: "group_work",
          //   color: "#DC143C",
          //   title: "Reports",
          //   page: "/reports",
          // },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
        ];
        break;
      case "ACCOUNT_MANAGER":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/manager-client-list",
          },
          // {
          //   icon: "group_work",
          //   color: "#DC143C",
          //   title: "Reports",
          //   page: "/reports",
          // },
        ];
        break;
      case "SITE_INCHARGE":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/incharge-client-list",
          },
          // {
          //   icon: "group_work",
          //   color: "#DC143C",
          //   title: "Reports",
          //   page: "/reports",
          // },
        ];
        break;
      case "OEM":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/OEM-Client",
          },
          // {
          //   icon: "group_work",
          //   color: "#DC143C",
          //   title: "Reports",
          //   page: "/reports",
          // },
        ];
        break;
    }
  }

  async fetchProductCount() {
    try {
      const apiUrl = `${BaseUrlConstantsService.PRODUCT_LIST_API}/22${this.customer === "CLIENT" ? this.userID : this.associated_clientid}2222`;
      const response: any = await this.service.getDataV2(apiUrl);
      console.log("------------Response from sidebar=-=========", response);
      if (response?.data?.status === "success") {
        this.rotatingAssetCount = response.data.body.body[0].count;
      } else {
        this.rotatingAssetCount = 0; // Default to 0 if api fails or no data
      }
      // Call this here to refresh the menu once the count is known
      this.updateMenuOptions();
    } catch (error) {
      console.log(error);
      this.rotatingAssetCount = 0;
      this.updateMenuOptions();
    }
  }
  /*
    - Fetches user profile picture depending upon userId and stores it in _userImg variable
    - CompanyLogo is fetched if found company logo is displayed instead of userImg
    - Commented by Sarthak on Feb 19, 2024
  */
  showProfileImage() {
    this._userImg = "";
    if (localStorage.getItem("loginStatus") === "yes") {
      this.service
        .getData(this.imageUploadUrl + "/" + localStorage.getItem("user_id"))
        .then((imgRes) => {
          if (JSON.parse(JSON.stringify(imgRes)).data.status === "success") {
            if (JSON.parse(JSON.stringify(imgRes)).data.body !== null) {
              if (JSON.parse(JSON.stringify(imgRes)).data.body.length !== 0) {
                this._userImg = JSON.parse(
                  JSON.stringify(imgRes)
                ).data.body[0].relative_url;
              }
            }
          }
        });
      this.service
        .getData(
          this.imageUploadUrl + "/logo/" + localStorage.getItem("user_id")
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status == "success") {
            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              if (
                (JSON.parse(JSON.stringify(res)).data.body[0].company_logo ==
                  " " ||
                JSON.parse(JSON.stringify(res)).data.body[0].company_logo ==
                  null) && (JSON.parse(JSON.stringify(res)).data.body[0].sub_user_logo ==
                  " " ||
                JSON.parse(JSON.stringify(res)).data.body[0].sub_user_logo ==
                  null)
              ) {
                this.showlogo = true;
                this.sub_user_logo = JSON.parse(JSON.stringify(res)).data.body[0].sub_user_logo;
              } else {
                this.showlogo = false;
                this.componyLogo = JSON.parse(
                  JSON.stringify(res)
                ).data.body[0].company_logo;
                this.sub_user_logo = JSON.parse(
                  JSON.stringify(res)
                ).data.body[0].sub_user_logo;
              }
            } else {
              this.showlogo = true;
            }
          }
        // console.log(this.sub_user_logo);
        this.updateMenuOptions()
        });
    }
  }
  /*
  - Navigates to https://dev.enertics.ca/#/admin-profile
  - Commented by Sarthak on Feb 19, 2024
 */
  openProfile() {
    this.router.navigate(["/admin-profile"]);
  }
  /*
    - If clicking on a navbar option is Alert Setting alertSettings() is called
    - Else if Operation Reports is selected user is navigated to https://dev.enertics.ca/#/operation-reports
    - Commented by Sarthak on Feb 19, 2024
  */
  actionOnClick(val: string) {
    this.selectedNav = val
    if (val.includes("Alert Settings")) {
      this.alertSettings();
    }
    switch (val) {
      case "Operational Reports":
        this.router.navigate(["/operation-reports"]);
        break;
        case "Home":
        this.router.navigate(["/admin-dashborad"]);
        break;
        case "Clients":
        this.router.navigate(["/clients"]);
        break;
        case "Devices":
        this.router.navigate(["/view-device-type"]);
        break;
        case "Site Incharge":
        this.router.navigate(["/site-incharge"]);
        break;
        case "Versioning":
        this.router.navigate(["/device-versioning"]);
        break;
        break;
        case "Licence":
        this.router.navigate(["/licence-management"]);
        break;
        case "Site Maintenance":
        this.router.navigate(["/site-maintenance"]);
        break;
        case "Reports":
        this.router.navigate(["/reports"]);
        break;
        case "Alerts":
        this.router.navigate(["/alert-list"]);
        break;
        case "Assets":
        this.router.navigate(["/device-reports"]);
        break;
        case "Users":
        this.router.navigate(["/users"]);
        break;
        case "Sites & Applications":
        this.router.navigate(["/site-groups"]);
        break;
        case "Device Usage":
        this.router.navigate(["/device-usage"]);
        break;
        case "Clients Subscription":
        this.router.navigate(["/clients-subscription"]);
        break;
        case "My Subscription":
        this.router.navigate(["/my-subscription"]);
        break;
        case "Uptime":
        this.router.navigate(["/uptime-dashboard"]);

    }
  }
  updateMenuOptions(){
    switch (localStorage.getItem("role")) {
      case "ADMIN":
        this.options = [
          {
            icon: "home",
            color: "#21b51d",
            title: "Home",
            page: "/admin-dashborad",
          },
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/clients",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Devices",
            page: "/view-device-type",
          },
          // {
          //   icon: "featured_play_list",
          //   color: "#bdd213",
          //   title: "Licence",
          //   page: "/licence-management",
          // }
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Account managers",
          //   page: "/admin-users",
          // },
          // {
          //   icon: "supervisor_account",
          //   color: "#00ffe7",
          //   title: "Site Incharge",
          //   page: "/site-incharge",
          // }
          {
            icon: "device-versioning",
            color: "#00ffe7",
            title: "Versioning",
            page: "/device-versioning",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Operational Reports",
            page: "/operation-reports",
          },
          {
            icon: "Site_maintenance",
            color: "#DC143C",
            title: "Site Maintenance",
            page: "/site-maintenance",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          },
          {
            icon: "Device Usage",
            color: "#DC143C",
            title: "Device Usage",
            page: "/device-usage",
          },
          {
            icon: "Clients Subscription",
            color: "#DC143C",
            title: "Clients Subscription",
            page: "/clients-subscription",
          }
        ];
        if(this.PRODUCTION === false) {
          this.options.push(       {
            icon: "Uptime",
            color: "#DC143C",
            title: "Uptime",
            page: "/uptime-dashboard",
          },);
        }
        break;
      case "CLIENT":
        // 1. Add Base Options (Always Visible)
        this.options = [
          {
            icon: "build",
            color: "#7FFFD4",
            title: "Assets",
            page: "/device-reports",
          },
          {
            icon: "account_circle",
            color: "#F0E68C",
            title: "Users",
            page: "/users",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Sites & Applications",
            page: "site-groups",
          },
          {
              icon: "group_work",
              color: "#DC143C",
              title: "Reports",
              page: "/reports",
          }
          
        ];

        // 2. Add Conditional Options if Rotating Asset Count > 0
        if (this.rotatingAssetCount && this.rotatingAssetCount > 0) {

          // Logic for Sub User Logo check for Reports
          // if (!this.sub_user_logo) {
          //   this.options.push({
          //     icon: "group_work",
          //     color: "#DC143C",
          //     title: "Reports",
          //     page: "/reports",
          //   });
          // }

          this.options.push(
            {
              icon: "group_work",
              color: "#DC143C",
              title: "Operational Reports",
              page: "/operation-reports",
            },
            {
              icon: "group_work",
              color: "#DC143C",
              title: "Alerts",
              page: "/alert-list",
            },
            {
              icon: "My Subscription",
              color: "#DC143C",
              title: "My Subscription",
              page: "/my-subscription",
            }
          );
        }
        break;
        case "USER":
        // 1. Add Base Options (Always Visible)
        this.options = [
          {
            icon: "dashboard",
            color: "#21b51d",
            title: "Assets",
            page: "/device-reports",
          }
        ];

        // 2. Add Conditional Options if Rotating Asset Count > 0
        if (this.rotatingAssetCount && this.rotatingAssetCount > 0) {

          // Logic for Sub User Logo check for Reports
          if (!this.sub_user_logo) {
            this.options.push({
              icon: "group_work",
              color: "#DC143C",
              title: "Reports",
              page: "/reports",
            });
          }

          this.options.push({
            icon: "group_work",
            color: "#DC143C",
            title: "Alerts",
            page: "/alert-list",
          });
        }
        break;
      case "ACCOUNT_MANAGER":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/manager-client-list",
          },
          {
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          },
        ];
        break;
      case "SITE_INCHARGE":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/incharge-client-list",
          },
          ...(this.sub_user_logo ? [] : [{
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          }]),
        ];
        break;
      case "OEM":
        this.options = [
          {
            icon: "face",
            color: "#FF8C00",
            title: "Clients",
            page: "/OEM-Client",
          },
          ...(this.sub_user_logo ? [] : [{
            icon: "group_work",
            color: "#DC143C",
            title: "Reports",
            page: "/reports",
          }]),
        ];
        break;
    }

}
  /*
    - This function is called if option selected is Alert Settings
    - Commented by Sarthak on Feb 19, 2024
  */
  public alertSettings(): void {
    const alertDialogRef = this.dialog.open(
      DialogOverviewExampleDialogComponent,
      {
        width: "1220px",
        maxWidth: "100%",
        disableClose: false,
        data: {
          type: "DefaultClientAlertStstem",
          clientId: localStorage.getItem("user_id"),
        },
      }
    );
  }
}
